/* eslint-disable */
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import './DeleteRoomForm.css';

import {
} from '../../actions';


class DeleteRoomForm extends OzFormComponent {

  static fields = [
    'disabled',
    'disabledReason',
  ]

  renderBody() {
    let disabledOptions = [
      [true, 'Delete/hide this room'],
      [false, 'Show this room'],
    ];

    let reasonOptions = [
      ['closed', 'Closed room'],
      ['not_open', 'Room not open yet'],
      ['not_escape', 'Not an escape room'],
      ['wrong_company', 'Wrong company'],
      ['duplicate', 'Duplicate listing'],
      ['incorrect', 'Incorrect listing'],
      ['other', 'Other reason'],
    ];

    return (
      <div className="DeleteRoomForm">
        {this.renderFormGroup('Delete/hide this room?', 'radio', 'disabled', disabledOptions)}
        {this.state.disabled && this.renderFormGroup('Why are you hiding this listing?', 'select', 'disabledReason', reasonOptions, { helptext: 'This will help us improve data quality on the site' })}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeleteRoomForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/DeleteRoomForm.js
 **/